'use strict';

var tslib = require('tslib');
var React = require('react');
var typography = require('@alfalab/core-components/typography');
var desktop = require('@alfalab/core-components/button/desktop');
var bemReactClassname = require('bem-react-classname');
require('./sms-sign-error.css');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

/**
 * Компонент вывода для ошибки подписания действия, блокирующей дальнейшую работу с окном подписания.
 * Например, если ввести код подписания неправильно 5 раз, то тогда будет исчерпан лимит попыток
 * подписания и правильный код перестанет подходить.
 */
var SmsSignError = /** @class */ (function (_super) {
    tslib.__extends(SmsSignError, _super);
    function SmsSignError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cn = bemReactClassname.createCn('sms-sign-error');
        return _this;
    }
    SmsSignError.prototype.render = function () {
        var _a = this.props, title = _a.title, error = _a.error, onRetryClick = _a.onRetryClick;
        return (React__default.default.createElement("div", { className: this.cn() },
            React__default.default.createElement(typography.Typography.TitleResponsive, { className: this.cn('header'), view: "xsmall", tag: "h4" }, title),
            React__default.default.createElement(typography.Typography.Text, { className: this.cn('text'), view: "secondary-large" }, error),
            React__default.default.createElement(desktop.ButtonDesktop, { className: this.cn('retry-button'), size: "xxs", view: "tertiary", onClick: onRetryClick }, "\u041F\u043E\u043F\u0440\u043E\u0431\u043E\u0432\u0430\u0442\u044C \u0437\u0430\u043D\u043E\u0432\u043E")));
    };
    SmsSignError.defaultProps = {
        title: '¯\\_(ツ)_/¯',
    };
    return SmsSignError;
}(React.PureComponent));

module.exports = SmsSignError;
